import { Grid, Typography } from "@material-ui/core";
import { isEmpty } from "lodash";
import moment from "moment";
import React from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { NoData } from "../../components";
import CardItem from "../../components/CardItem";

const SponsoredSessionsTab = ({ exhibitorSessions = [] }) => {
  const intl = useIntl();
  const history = useHistory();

  const futureExhibitorSessions = exhibitorSessions.filter(({ programEvent }) =>
    moment(programEvent.startAt).isAfter()
  );

  const pastExhibitorSessions = exhibitorSessions
    .filter(({ programEvent }) => !moment(programEvent.startAt).isAfter())
    .map(({ recordings, ...s }) => ({
      ...s,
      videoUrl: !isEmpty(recordings) && recordings[0].videoUrl
    }));

  return (
    <>
      <NoData data={futureExhibitorSessions} noRender>
        <Typography variant="h5">
          {intl.formatMessage({
            id: "Exhibitors.SponsoredSessionsTab.UpcomingSponsoredSessions",
            defaultMessage: "Upcoming Sponsored Sessions"
          })}
        </Typography>

        <Grid container spacing={3}>
          {futureExhibitorSessions.map(({ id, title, thumbUrl, programEvent }) => (
            <Grid key={id} item xs={12} sm={3}>
              <CardItem
                title={title}
                programEvent={programEvent}
                thumbUrl={thumbUrl}
                onClick={() => {
                  history.push(`/sessions/${id}`);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </NoData>

      <NoData data={pastExhibitorSessions} noRender>
        <Typography variant="h5">
          {intl.formatMessage({
            id: "Exhibitors.SponsoredSessionsTab.SponsoredSessions",
            defaultMessage: "Sponsored Sessions"
          })}
        </Typography>
        <Grid container spacing={3}>
          {pastExhibitorSessions.map(({ id, title, thumbUrl }) => (
            <Grid key={id} item xs={12} sm={3}>
              <CardItem
                title={title}
                thumbUrl={thumbUrl}
                duration={`${0}:${0}`}
                onClick={() => {
                  history.push(`/sessions/${id}`);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </NoData>
    </>
  );
};

export default SponsoredSessionsTab;
